import React from "react";
import { EnquiryForm } from "../../components";

const Form = () => {
  return (
    <div className="bg-white py-[60px] w-full flex items-center justify-center px-8 xl:px-0">
      <div className="h-full relative max-w-screen-xl flex flex-wrap items-center w-full justify-center flex-col md:flex-row">
        <p className="text-7xl text-blue-5">
          We are waiting to hear from you...
        </p>
        <div className="w-full md:w-1/2">
          <img
            src="/assets/images/contact/contact-bg.png"
            alt=""
            className="w-[600px]"
          />
        </div>
        <div className="w-full md:w-1/2 flex flex-col items-center">
          <EnquiryForm color={"bg-blue-0"} selectColor={"#E8E9F1"} />
        </div>
      </div>
    </div>
  );
};

export default Form;
